import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {LocationCardScratchpadState} from '../../scratchpad/locationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {LocationTargetingMethodValue} from 'common/src/modules/locationFeed/locationFeed.types';

const setMaxDistanceToolSchema = z.object({
  maxDistKm: z.number().describe('The maximum distance in kilometers'),
  maxDistFallbackOption: z
    .number()
    .optional()
    .nullable()
    .describe('The fallback option when no location is within max distance'),
});

export default function setMaxDistanceTool() {
  async function execute(
    params: ToolExecuteParams<typeof setMaxDistanceToolSchema, LocationCardScratchpadState>,
  ) {
    const {maxDistKm, maxDistFallbackOption} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<LocationCardScratchpadState>(
      agentScratchpad,
      NodeType.STORE,
    );

    if (!maxDistKm) {
      return toolResult('No max distance provided');
    }

    if (
      validatedScratchpad.card.locationTargetingMethod !==
      LocationTargetingMethodValue.NearestLocation
    ) {
      return toolResult(
        'Max distance should be set only for Nearest Location targeting method. Either set the location targeting method to Nearest Location or remove the max distance.',
      );
    }

    validatedScratchpad.card.maxDistKm = maxDistKm;

    return toolResult(
      `Max distance set to: ${maxDistKm}km${maxDistFallbackOption ? `, fallback option: ${maxDistFallbackOption}` : ''}`,
    );
  }

  return tool({
    name: V2CardAgentToolName.SetMaxDistance,
    displayName: 'Setting max distance',
    description:
      'Set the maximum distance in kilometers and fallback option for proximity-based targeting',
    execute,
    inputSchema: setMaxDistanceToolSchema,
  });
}
